import {
  getCountries,
  getCountryCallingCode,
  type CountryCode,
} from "libphonenumber-js"

const regionDisplayNames = typeof Intl.DisplayNames === "function"
  ? new Intl.DisplayNames(["en"], { type: "region" })
  : null

export const META_PHONE_COUNTRY_OPTIONS = getCountries()
  .map(countryCode => ({
    value: countryCode,
    label: formatCountryLabel(countryCode),
  }))
  .toSorted((left, right) => left.label.localeCompare(right.label))

function formatCountryLabel(countryCode: CountryCode): string {
  const countryName = regionDisplayNames?.of(countryCode) ?? countryCode
  return `${countryName} (${countryCode}, +${getCountryCallingCode(countryCode)})`
}
